import {
  spell
} from 'helpers/international_spelling';

angular.module('filters').filter('spell', ["$rootScope", function($rootScope) {
  return function(key, country) {
    var ref, resolvedCountry;
    resolvedCountry = country || ($rootScope != null ? (ref = $rootScope.gym) != null ? ref.country : void 0 : void 0);
    return spell(key, resolvedCountry);
  };
}]);
